<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <Tab type="coupon" />

      <div class="page-actions">
        <div class="select">
          <div class="item">
            <div class="ipt">
              <el-input
                v-model.trim="filters.couponIdOrName"
                placeholder="卡券ID/名称"
                clearable
                size="mini"
                prefix-icon="el-icon-search"
                @keyup.enter.native="handleSearch"
              />
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select
                v-model="filters.couponType"
                placeholder="卡券类型"
                size="mini"
                style="width: 160px"
              >
                <el-option
                  v-for="item in couponTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select
                v-model="filters.couponStatus"
                placeholder="卡券状态"
                size="mini"
                style="width: 140px"
              >
                <el-option
                  v-for="item in couponStatusOptions"
                  :key="item.label"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
          <div class="item">
            <el-button size="mini" type="primary" @click="openAdd">添加卡券</el-button>
          </div>
          <div class="item">
            <el-button size="mini" type="primary" @click="handleSearch">查询</el-button>
          </div>
          <div class="item">
            <el-button size="mini" @click="handleReset">重置</el-button>
          </div>
        </div>
      </div>

      <el-table
        :data="tableList"
        height="calc(100vh - 320px)"
        size="mini"
        v-loading="loading"
      >
        <el-table-column
          prop="couponNo"
          label="卡券ID"
          min-width="200"
          show-overflow-tooltip
        />
        <el-table-column
          prop="couponName"
          label="卡券名称"
          min-width="140"
          show-overflow-tooltip
        />
        <el-table-column prop="couponType" label="卡券类型" min-width="150">
          <template slot-scope="scope">
            {{ scope.row.couponTypeDesc || couponTypeMap[scope.row.couponType] || scope.row.couponType || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="validDays" label="卡券有效期" min-width="110">
          <template slot-scope="scope">{{ scope.row.validDays ? `${scope.row.validDays}天` : '-' }}</template>
        </el-table-column>
        <el-table-column prop="vipLevel" label="VIP等级" min-width="90">
          <template slot-scope="scope">{{ scope.row.vipLevel ? `VIP${scope.row.vipLevel}` : '-' }}</template>
        </el-table-column>
        <el-table-column prop="vipValidDays" label="VIP有效期" min-width="105">
          <template slot-scope="scope">{{ scope.row.vipValidDays ? `${scope.row.vipValidDays}天` : '-' }}</template>
        </el-table-column>
        <el-table-column prop="userTypeName" label="用户类别" min-width="120">
          <template slot-scope="scope">{{ scope.row.userTypeName || '-' }}</template>
        </el-table-column>
        <el-table-column label="发放时间" min-width="260">
          <template slot-scope="scope">
            <span v-if="scope.row.grantStartTime">{{ scope.row.grantStartTime | moment }} - {{ scope.row.grantEndTime | moment }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="deductRate" label="抵扣比例(1-100)" min-width="130">
          <template slot-scope="scope">
            {{ formatRate(scope.row.deductRate) }}
          </template>
        </el-table-column>
        <el-table-column prop="coin" label="币种" width="80">
          <template slot-scope="scope">{{ formatValue(scope.row.coin) }}</template>
        </el-table-column>
        <el-table-column prop="amount" label="卡券金额" min-width="100">
          <template slot-scope="scope">{{ formatValue(scope.row.amount) }}</template>
        </el-table-column>
        <el-table-column prop="couponStatus" label="卡券状态" min-width="100">
          <template slot-scope="scope">
            <el-tag
              size="mini"
              :type="statusTag(scope.row).type"
            >
              {{ scope.row.couponStatusDesc || statusTag(scope.row).text }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="updatedTime" label="更新时间" min-width="160">
          <template slot-scope="scope">
            {{ scope.row.updatedTime | moment }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="openView(scope.row)">详情</el-button>
            <el-button type="text" size="mini" @click="openCopy(scope.row)">复制</el-button>
            <el-button
              v-if="canEdit(scope.row)"
              type="text"
              size="mini"
              @click="openEdit(scope.row)"
            >
              修改
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pag">
        <pagination
          :size="pagination.size"
          :total="totalCount"
          :page="pagination.page"
          @pageChanged="pageChanged"
        />
      </div>

      <CouponFormDialog
        v-model="formVisible"
        :mode="formMode"
        :coupon-id="currentId"
        @success="fetchList"
      />
    </el-card>
  </div>
</template>

<script>
import Pagination from 'components/pagination'
import Tab from '../components/Tab'
import CouponFormDialog from './components/CouponFormDialog.vue'
import api from './api'
import {
  PAGINATION,
  COUPON_TYPE_OPTIONS,
  COUPON_TYPE_MAP,
  COUPON_STATUS,
  COUPON_STATUS_OPTIONS,
  COUPON_STATUS_TAG,
} from './constants'

function createFilters() {
  return {
    couponIdOrName: '',
    couponType: '',
    couponStatus: '',
  }
}

export default {
  name: 'WelfareCoupon',
  components: { Pagination, Tab, CouponFormDialog },
  data() {
    return {
      loading: false,
      filters: createFilters(),
      couponTypeOptions: COUPON_TYPE_OPTIONS,
      couponTypeMap: COUPON_TYPE_MAP,
      couponStatusOptions: COUPON_STATUS_OPTIONS,
      tableList: [],
      totalCount: 0,
      pagination: { ...PAGINATION },
      formVisible: false,
      formMode: 'add',
      currentId: null,
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    formatValue(value) {
      return value === null || value === undefined || value === '' ? '--' : value
    },
    formatRate(rate) {
      if (rate === null || rate === undefined || rate === '') return '-'
      return `${rate}%`
    },
    statusTag(row) {
      return (
        COUPON_STATUS_TAG[row.couponStatus] || {
          text: row.couponStatusDesc || row.couponStatus || '-',
          type: 'info',
        }
      )
    },
    canEdit(row) {
      if (row.canEdit === true) return true
      return row.couponStatus === COUPON_STATUS.WAIT_GRANT
    },
    handleSearch() {
      this.pagination.page = 1
      this.fetchList()
    },
    handleReset() {
      this.filters = createFilters()
      this.pagination = { ...PAGINATION }
      this.fetchList()
    },
    pageChanged({ page, size }) {
      this.pagination = { page, size }
      this.fetchList()
    },
    buildQuery() {
      const query = {
        page: this.pagination.page,
        size: this.pagination.size,
      }
      if (this.filters.couponType) query.couponType = this.filters.couponType
      if (this.filters.couponIdOrName) {
        query.couponIdOrName = this.filters.couponIdOrName
      }
      if (this.filters.couponStatus) {
        query.couponStatus = this.filters.couponStatus
      }
      return query
    },
    fetchList() {
      this.loading = true
      api
        .list(this.buildQuery())
        .then((res) => {
          if (res && res.code === 0) {
            const d = res.data || {}
            this.tableList = d.items || d.records || d.list || []
            this.totalCount =
              d.total != null ? d.total : d.totalCount != null ? d.totalCount : 0
          } else {
            this.tableList = []
            this.totalCount = 0
            this.$message.error((res && res.msg) || '查询失败')
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    openAdd() {
      this.formMode = 'add'
      this.currentId = null
      this.formVisible = true
    },
    openView(row) {
      this.formMode = 'view'
      this.currentId = row.id
      this.formVisible = true
    },
    openCopy(row) {
      this.formMode = 'copy'
      this.currentId = row.id
      this.formVisible = true
    },
    openEdit(row) {
      this.formMode = 'edit'
      this.currentId = row.id
      this.formVisible = true
    },
  },
}
</script>

<style lang="less" src="../../../styles/button.less" scoped></style>
<style lang="less" scoped>
.pag {
  display: flex;
  justify-content: center;
}
</style>
